import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function Edit2({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 24"
    >
      <Path
        d="M10 16.6667H8V14.6667L16.1953 6.47142L18.1953 8.47143L10 16.6667Z"
        fill={iconColor}
      />
      <Path
        d="M19.1381 7.52862L17.1381 5.52862L19 3.66669L21 5.66669L19.1381 7.52862Z"
        fill={iconColor}
      />
      <Path
        d="M16 19.3334V12.5523L17.3333 11.219V20.6667H4V7.33335H13.4477L12.1144 8.66669H5.33333V19.3334H16Z"
        fill={iconColor}
      />
    </Svg>
  );
}
